import * as React from "react";
const SvgFiRrTamale = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M2.756 12.11a1 1 0 0 0 .994.89h16.5a1 1 0 0 0 .994-.89l.8-7.188A4 4 0 0 0 18.7.529a42.5 42.5 0 0 0-6.688-.527L12 0l-.012.002C9.734.002 7.48.178 5.3.53a4 4 0 0 0-3.342 4.393l.8 7.188zM13 2.022q1.264.029 2.517.136l-.465 8.843h-2.05V2.022zM11 11H8.95l-.466-8.843a41 41 0 0 1 2.517-.136V11m9.055-6.298-.7 6.298h-2.3l.452-8.617c.292.04.585.076.875.122a2 2 0 0 1 1.673 2.197M5.618 2.505c.29-.047.583-.082.875-.122L6.946 11h-2.3l-.7-6.298a2 2 0 0 1 1.672-2.197m16.424 16.572A4 4 0 0 1 18.7 23.47c-2.185.352-4.438.53-6.7.53s-4.516-.178-6.7-.53a4 4 0 0 1-3.343-4.393l.355-3.188a1 1 0 1 1 1.987.221l-.354 3.188a2 2 0 0 0 1.673 2.197c.29.047.583.082.875.122l.298-5.67c.03-.551.51-.976 1.051-.946a1 1 0 0 1 .946 1.051l-.305 5.79q1.253.106 2.517.136V16a1 1 0 0 1 2 0v5.978q1.264-.029 2.517-.136l-.305-5.79a1 1 0 0 1 .946-1.051c.554-.043 1.022.394 1.051.946l.298 5.67c.292-.04.585-.076.875-.122a2 2 0 0 0 1.673-2.197l-.354-3.188a1 1 0 1 1 1.987-.221z"
    />
  </svg>
);
export default SvgFiRrTamale;
